<template>
  <TheGreyWrapper>
    <TheHeader
      :back-route="computedBackRoute"
      force-sm-style
    />
    <BaseSection>
      <BaseTitleGroup
        :title="$t('Investment entity creation')"
        :subtitle="opportunity && `${$t('Opportunities')} / ${opportunity.data.attributes.name}`"
        class="mb-8"
      />
      <form @submit.prevent="submit()">
        <BaseInputGroup
          v-model="registrationNumber"
          :label="$t('Registration Number')"
          :class="{
            'mb-12': formIsCollapsed,
            'mb-4': !formIsCollapsed,
          }"
          type="tel"
          maxlength="11"
          pattern="[0-9\s]{0,11}"
          required
        />
        <div
          :class="{
            'visible-form': !formIsCollapsed,
            'max-h-0': formIsCollapsed,
          }"
          class="overflow-hidden custom-transition"
        >
          <BaseInputGroup
            v-model="companyType"
            :label="$t('Company type')"
            type="text"
            class="mb-4"
            autofocus
            required
          />
          <BaseInputGroup
            v-model="lastname"
            :label="$t('Lastname')"
            type="text"
            class="mb-4"
            required
          />
          <BaseInputGroup
            v-model="address"
            :label="$t('Address')"
            type="text"
            class="mb-4"
            required
          />
          <BaseInputGroup
            v-model="zipCode"
            :label="$t('Zip code')"
            type="text"
            pattern="[0-9]+"
            class="mb-4"
            required
          />
          <BaseInputGroup
            v-model="city"
            :label="$t('City')"
            type="text"
            class="mb-4"
            required
          />
          <BaseSelect
            v-model="country"
            :label="$t('Country')"
            :options="countries"
            value-property="code"
            track-by="code"
            select-label="name"
            class="mb-4"
            required
          />
          <BaseInputGroup
            v-model="companyLegalRepresentativeName"
            :label="$t('Company legal representative name')"
            type="text"
            class="mb-4"
            required
          />
          <BaseInputGroup
            v-model="companyLegalRepresentativeFunction"
            :label="$t('Company legal representative function')"
            type="text"
            class="mb-12"
            required
          />
        </div>
        <BaseButton
          :title="$t('Confirm')"
          :theme="formIsCollapsed && 'disabled' || 'primary'"
          class="mb-8"
        />
      </form>
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import loadOpportunity from '../mixins/loadOpportunity';
import investmentEntityCreation from '../mixins/investmentEntityCreation';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseInputGroup from '../components/BaseInputGroup.vue';
import BaseButton from '../components/BaseButton.vue';
import BaseSelect from '../components/BaseSelect.vue';
import TheHeader from '../components/TheHeader.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';

export default {
  name: 'InvestmentEntityCompanyCreation',
  components: {
    BaseSection,
    BaseTitleGroup,
    TheHeader,
    BaseInputGroup,
    BaseButton,
    TheGreyWrapper,
    BaseSelect,
  },
  mixins: [loadOpportunity, investmentEntityCreation],
  computed: {
    ...mapFields('investmentEntity', [
      'form.companyLegalRepresentativeFunction',
      'form.companyLegalRepresentativeName',
      'form.companyType',
      'form.lastname',
      'form.address',
      'form.zipCode',
      'form.city',
      'form.country',
      'form.birthDate',
    ]),
    registrationNumber: {
      get() {
        return this.$store.state.investmentEntity.form.registrationNumber;
      },
      set(newValue) {
        const result = newValue.replace(/\D/g, '').substr(0, 9)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ').substr(0, 11);
        this.$nextTick(() => this.updateRegistrationNumber(result));
      },
    },
    formIsCollapsed() {
      return (!this.registrationNumber || this.registrationNumber.length !== 11);
    },
  },
  methods: {
    ...mapActions('investmentEntity', ['create', 'updateRegistrationNumber']),
    submit() {
      if (this.entityId) {
        this.update().then(this.returnToProfile);
      } else {
        const opportunityId = this.$route.params.id;
        this.create({ kind: 'Company', opportunityId }).then(() => {
          if (opportunityId) {
            this.$router.push('../confirmation');
          } else {
            this.$router.push('/profile');
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-transition {
  transition: max-height .5s;
}
.visible-form {
  max-height: 1000px;
}
</style>
